/* src/app/features/renuncia/renuncia-limite-adicional/pesquisa/pesquisa.component.scss */
/*# sourceMappingURL=pesquisa.component.css.map */
